import { combineReducers } from 'redux';
import auth from './auth';
import barSize from './barSize';
// import coinData from './cmcCoins';
import settings from './settings';
import publicList from './publicList';
// import marketLists from './marketLists';

export default combineReducers({
    auth: auth,
    barSize: barSize,
    // coinData: coinData,
    publicList: publicList,
    settings: settings,
    // marketLists: marketLists    
});
